import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
  status: null,
  options: [],
  message: null,
  displayname: {}
};

export const getAssociationType = createAsyncThunk(
  "getAssociationType",
  async (data) => {
    try {
      const response = await fetch(`/api/getAssociationType/${data.configId}/${data.locale}`, {
        method: "GET"
      });
      if (!response.ok) {
        throw new Error("Failed to fetch attributes");
      }
      return await response.json();
    } catch (error) {
      throw new Error(error.message);
    }
  }
);

const credentialsSlice = createSlice({
  name: "getAssociationType",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getAssociationType.pending, (state) => {
        state.status = "PIM loading";
        state.message = null;
      })
      .addCase(getAssociationType.fulfilled, (state, action) => {
        state.status = "PIM loaded";
        state.options = [];  // Clear the existing data
        state.options = action.payload.data.data?.associationtype?.map((item) => ({
          value: item.code,
          label: item.displayname
        }));
        action.payload.data.data?.associationtype?.forEach((item) => {
          state.displayname[item.code] = item.displayname
        });

      })
      .addCase(getAssociationType.rejected, (state, action) => {
        state.status = "error";
        state.message = action.error.message;
      });
  },
});

export default credentialsSlice.reducer;
